import React, { useState, useEffect } from 'react';
import { Container, Typography, Button, Paper, Table, TableBody, TableCell,
         TableContainer, TableHead, TableRow, Box, CircularProgress } from '@mui/material';
import { getAdminProducts, deleteProduct } from '../../services/api';
import { Link } from 'react-router-dom';

function AdminProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await getAdminProducts();
      // Check if products array is inside response.data.products
      if (response.data.products) {
        setProducts(response.data.products);
      } else {
        // it Fallback if the response structure is different
        setProducts(response.data);
      }
    } catch (error) {
      console.error('Failed to fetch products:', error);
    } finally {
    setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this product?')) {
      try {
        await deleteProduct(id);
        fetchProducts(); // Refresh the list
      } catch (error) {
        console.error('Failed to delete product:', error);
      }
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4">Manage Products</Typography>
        <Button
          variant="contained"
          component={Link}
          to="/admin/products/add"
        >
          Add New Product
        </Button>
      </Box>

      <Paper sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6">No products found</Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
          Add your first product to get started
        </Typography>
      </Paper>
    </Container>
  );
}

export default AdminProducts;